import { useSPIntl } from 'hooks/useIntl';
import { IntlKey } from 'locales';
import { useCallback } from 'react';
import { camelCaseToWords } from 'utils/string';

export const useSolveModeTranslation = () => {
  const { formatMessage } = useSPIntl();

  return useCallback(
    (solveMode?: string) => {
      const key = `field.${solveMode}` as IntlKey;
      const defaultMessage = solveMode ? solveMode : camelCaseToWords(solveMode);
      return formatMessage({ id: key, defaultMessage });
    },
    [formatMessage],
  );
};
